import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './AdminLayout.css';
import { API_URL } from '../../Api/api';
import {
  applyAdminTheme,
  loadAdminTheme,
  loadSidebarPinned,
  saveSidebarPinned,
} from './adminUiPrefs';

const AdminLayout = () => {
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [pinned, setPinned] = useState(() => loadSidebarPinned());
  const layoutRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('admin_access_token');
    if (!token) {
      navigate('/admin/login');
      return;
    }

    const storedUser = localStorage.getItem('adminUser');
    if (storedUser) {
      try { setUser(JSON.parse(storedUser)); } catch { /* ignore a bad cache */ }
    }
    axios.get(`${API_URL}/admin/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (!res.data?.email) return;
        localStorage.setItem('adminUser', JSON.stringify(res.data));
        setUser(res.data);
      })
      .catch(() => {
        if (!storedUser) navigate('/admin/login');
      });
  }, [navigate]);

  useEffect(() => {
    applyAdminTheme(layoutRef.current, loadAdminTheme());
    const onTheme = (event) => {
      applyAdminTheme(layoutRef.current, event.detail || loadAdminTheme());
    };
    window.addEventListener('pif-admin-theme', onTheme);
    return () => window.removeEventListener('pif-admin-theme', onTheme);
  }, [user]);

  const togglePin = () => {
    const next = !pinned;
    setPinned(next);
    saveSidebarPinned(next);
    setSidebarOpen(next);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  if (!user) return null;

  return (
    <div
      ref={layoutRef}
      className={`admin-layout ${pinned ? 'sidebar-pinned' : 'sidebar-unpinned'} ${sidebarOpen ? 'sidebar-drawer-open' : ''}`}
    >
      {!pinned && sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}
      <Sidebar
        userRole={user.role}
        isSuperAdmin={user.is_super === 1}
        isOpen={sidebarOpen}
        onClose={closeSidebar}
        basePath="/admin"
        adminUserChatAccess={user.user_chat_access !== false}
        pinned={pinned}
        onTogglePin={togglePin}
      />
      <main className="admin-main">
        <Header
          user={user}
          onMenuToggle={() => setSidebarOpen((open) => !open)}
          basePath="/admin"
          userChatAccess={user.user_chat_access !== false}
        />
        <div className="admin-content">
          <Outlet key={location.pathname} />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
